import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

const InputSection = (props) => {
    const { title, description, children, style = {} } = props;

    return(
        <View style={[styles.container, style]}>
            {title && (
                <View style={styles.header}>
                    <Text style={styles.title}>{title}</Text>
                </View>
            )}
            {description && <Text style={styles.desc}>{description}</Text>}
            <View style={styles.content}>
                {children}
            </View>
        </View>
    )
}

const styles = StyleSheet.create(({colors, fonts, shadows, spacing}) => ({
    container: {
        backgroundColor: colors.surface,
        borderRadius: 14,
        marginVertical: spacing.sm,
        boxShadow: shadows.card,
        overflow: 'hidden',
    },
    header: {
        paddingTop: spacing.md,
        paddingHorizontal: spacing.md + 4,
        paddingBottom: spacing.xs,
    },
    title: {
        fontSize: 13,
        color: colors.textSecondary,
        fontFamily: fonts.bold,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
    },
    desc: {
        fontSize: 13,
        lineHeight: 18,
        color: colors.textTertiary,
        paddingHorizontal: spacing.md + 4,
        paddingBottom: spacing.xs,
    },
    content: {
        paddingHorizontal: spacing.md + 4,
        paddingTop: spacing.xs,
        paddingBottom: spacing.md,
    },
}));

export default InputSection